import 'flag-icons/css/flag-icons.min.css';

// A small country flag (SVG from the flag-icons package, so it shows on Windows too).
export function Flag({ country, name }: { country: string | null | undefined; name?: string | null }) {
  if (!country) return null;
  return <span className={`fi fi-${country.toLowerCase()} flag`} role="img" aria-label={name ?? country} title={name ?? country} />;
}
